var _ = require('underscore');
var StatusType = EY.Consultation.Lookups.StatusType;

var set = function (options) {
    var optionsRecord = options.record;
    var expiryRules = [
        {
            condition: function (record) { return record.get('statusTypeId') === StatusType.Draft; },
            expiryAt: function (record) {
                return new Date(record.get('createdOn') || new Date()).addDays(60);
            }
        },
        {
            condition: function (record) { return record.get('statusTypeId') === StatusType.ReviewApproval; },
            expiryAt: function (record) {
                var approvalBy = new Date(record.get('approvalBy'));
                var createdOn = new Date(record.get('createdOn'));
                var expiry = record.get('approvalBy') ? approvalBy.addDays(60) : createdOn.addDays(365); //AM
                if (expiry.getTime() > createdOn.addDays(365).getTime()) {
                    expiry = createdOn.addDays(365);
                }
                return expiry;
            }
        }
    ];

    optionsRecord.set('expiryAt', new Date('3000-01-01')); //If expiryAt is not set then default to maxDate
    _.each(expiryRules, function (rule) {
        rule.condition(optionsRecord) && optionsRecord.set('expiryAt', rule.expiryAt(optionsRecord));
    });
};

module.exports.set = function (options) {
    set(options);
};


// WEBPACK FOOTER //
// ./js/Modules/Record/Service/RecordExpiry.js